import TextArea from './TextArea';
import withReadyOnlyAbility from '../ReadOnlyAbilityWrapper';
import { wrapInLabel } from '../NewInputLabelWrapper';
import { withFormMeta } from '../../FormMeta';

export default withFormMeta(withReadyOnlyAbility(wrapInLabel(TextArea)));
